import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AgentCapabilityService } from '../services/agent-capability.service';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { MatDialog } from '@angular/material';
import { AgentCapabilitiesDetailsComponent } from './agent-capabilities-details/agent-capabilities-details.component';

@Component({
  selector: 'app-agent-capabilities',
  templateUrl: './agent-capabilities.component.html',
  styleUrls: ['./agent-capabilities.component.css']
})
export class AgentCapabilitiesComponent implements OnInit {

  @Output() loaded: EventEmitter<any> = new EventEmitter();

  isLoaded: boolean = false;

  machineCapabilities: {
    machineNames: string[],
    capabilities: {
      capabilityName: string,
      capabilityPerMachine: {
        agentName: string,
        machineName: string,
        value: string
      }[],
      capabilityType: string
    }[]
  };

  constructor(
    private agentCapabilityService: AgentCapabilityService,
    private notificationService: NotificationService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loadReport();
  }

  loadReport(): void {
    this.agentCapabilityService.getCapabilities()
      .source.pipe(finalize(() => {
        this.isLoaded = true;
        this.loaded.emit(null);
      }))
      .subscribe(response => {
        const anEmptyModel = {
          machineNames: [''],
          capabilities: [{ capabilityName: '', capabilityType: '', capabilityPerMachine: [{agentName: '', machineName: '', value: ''}]}]
        };
        if (response && response.ok) {
          this.machineCapabilities = response.body as any;
        } else if (response && !response.ok) {
          this.notificationService.showError(`Error loading agent capabilities: ${response.error}`)
          this.machineCapabilities = anEmptyModel;
        } else {
          this.machineCapabilities = anEmptyModel;
        }
      })
  }

  showCapabilityDetails(cap, event: any): void {

    event.stopPropagation();
    event.preventDefault();

    const machines: string[] = (this.machineCapabilities as any).machineNames;
    const capabilities: any[] = cap.capabilityPerMachine;

    let data: {key: string, value: string }[] = [];
    for (let i = 0; i < machines.length; i++) {
      if (capabilities[i].value !== null) {
        data.push({ key: machines[i], value: capabilities[i].value});
      }
    }

    this.dialog.open(AgentCapabilitiesDetailsComponent, {
      data: {
        name: cap.capabilityName,
        capabilities: data
      }
    });
  }
}
